'use client'

import * as SwitchPrimitives from '@radix-ui/react-switch'
import { cva, type VariantProps } from 'class-variance-authority'
import type { ComponentProps } from 'react'
import { cn } from '@/src/utils/styles'

const switchVariants = cva(
  'peer inline-flex shrink-0 cursor-pointer items-center rounded-2xl border-2 border-transparent transition-colors focus-outer disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-orange-400 data-[state=unchecked]:bg-surface2 disabled:opacity-50 disabled:pointer-events-none',
  {
    variants: {
      size: {
        default: 'h-6 w-11',
        large: 'h-8 w-[52px]',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
)

type SwitchProps = ComponentProps<typeof SwitchPrimitives.Root> &
  VariantProps<typeof switchVariants>

const Switch = ({ className, size, ref, ...props }: SwitchProps) => (
  <SwitchPrimitives.Root
    className={cn(switchVariants({ className, size }))}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        'pointer-events-none block rounded-full bg-gray-50 shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-5 data-[state=unchecked]:translate-x-0',
        !size || size === 'default' ? 'h-5 w-5' : 'h-7 w-7',
      )}
    />
  </SwitchPrimitives.Root>
)
Switch.displayName = SwitchPrimitives.Root.displayName

export { Switch }
